
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    pagePage: {
        minHeight: '100vh',
        width: '100%',
        margin: 0,
        padding: 0,
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        backgroundImage: `url(${require('../images/PBDQHomePage.png')})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed',
        display: 'flex',
        flexDirection: 'column',
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '12px 15px',
        backgroundColor: 'var(--brand-surface, #fff)',
        boxShadow: '0 2px 10px rgba(0,0,0,0.02)',
        position: 'sticky',
        top: 0,
        zIndex: 1000,
    },
    logo: {
        height: '60px',
        [theme.breakpoints.down('sm')]: {
            height: '55px',
        },
    },
    nav: {
        display: 'flex',
        gap: '40px',
        marginLeft: '40px',
        [theme.breakpoints.down('md')]: {
            display: 'none',
        },
    },
    navLink: {
        textDecoration: 'none',
        color: 'var(--brand-text, #333)',
        fontWeight: 500,
        fontSize: '16px',
        '&:hover': {
            color: '#F15A24',
        },
    },
    profileIcon: {},
    hero: {
        padding: '80px 20px 40px',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        [theme.breakpoints.down('sm')]: {
            padding: '40px 15px 20px',
        },
    },
    card: {
        width: '100%',
        maxWidth: '1000px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    iconBox: {
        marginBottom: '20px',
    },
    heroPill: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '7px',
        background: 'var(--brand-surface, rgba(0,0,0,0.06))',
        border: '1px solid var(--brand-border, rgba(0,0,0,0.1))',
        borderRadius: '100px',
        padding: '6px 16px',
        fontSize: '13px',
        fontWeight: '500',
        color: 'var(--brand-text, #333)',
        marginBottom: '20px',
        letterSpacing: '0.01em',
    },
    heroPillIcon: {
        fontSize: '14px',
        color: 'var(--brand-text-muted, #555)',
        lineHeight: 1,
    },
    title: {
        fontSize: '46px !important',
        lineHeight: '1.1 !important',
        fontWeight: '800 !important',
        margin: '0 0 16px 0 !important',
        color: 'var(--brand-text, #0a0a0a)',
        maxWidth: '800px',
        textAlign: 'center',
        letterSpacing: '-0.5px',
        [theme.breakpoints.down('sm')]: {
            fontSize: '26px !important',
        },
    },
    titleSub: {
        fontSize: '38px !important',
        lineHeight: '1.2 !important',
        fontWeight: '300 !important',
        margin: '0 0 24px 0 !important',
        color: 'var(--brand-text, #0a0a0a)',
        maxWidth: '800px',
        textAlign: 'center',
        letterSpacing: '-0.3px',
        [theme.breakpoints.down('sm')]: {
            fontSize: '22px !important',
        },
    },
    subtitle: {
        fontSize: '17px !important',
        color: 'var(--brand-text, #1a1a1a) !important',
        marginBottom: '28px !important',
        fontWeight: '700 !important',
        lineHeight: '1.4 !important',
        textAlign: 'center',
        [theme.breakpoints.down('sm')]: {
            fontSize: '15px !important',
            marginBottom: '16px !important',
        },
    },
    inputRow: {
        position: 'relative',
        width: '100%',
        maxWidth: '700px',
        marginBottom: '40px',
        [theme.breakpoints.down('sm')]: {
            marginBottom: '20px',
        },
    },
    frameworksPanel: {
        position: 'absolute',
        left: 'calc(100% + 16px)',
        top: 0,
        background: 'transparent',
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        width: '330px',
        maxWidth:'430px',
        [theme.breakpoints.down('md')]: {
            display: 'none',
        },
    },
    frameworksTitle: {
        fontSize: '14px !important',
        fontWeight: '700 !important',
        color: 'var(--brand-text, #111)',
        lineHeight: '1.4 !important',
        marginBottom: '2px !important',
        textAlign: 'left',
    },
    '@keyframes fwFadeIn': {
        '0%':   { opacity: 0, transform: 'translateY(10px)' },
        '100%': { opacity: 1, transform: 'translateY(0)' },
    },
    '@keyframes fwFadeOut': {
        '0%':   { opacity: 1, transform: 'translateY(0)' },
        '100%': { opacity: 0, transform: 'translateY(-10px)' },
    },
    frameworkPill: {
        background: 'var(--brand-surface, #fff)',
        borderRadius: '14px',
        padding: '10px 16px',
        fontSize: '13px',
        fontWeight: '500',
        color: 'var(--brand-text, #333)',
        textAlign: 'left',
        animation: '$fwFadeIn 0.4s ease forwards',
    },
    frameworkPillExiting: {
        background: 'var(--brand-surface, #fff)',
        borderRadius: '14px',
        padding: '10px 16px',
        fontSize: '13px',
        fontWeight: '500',
        color: 'var(--brand-text, #333)',
        textAlign: 'left',
        animation: '$fwFadeOut 0.4s ease forwards',
        pointerEvents: 'none',
    },
    helpTextIcon: {
        fontSize: '18px !important',
        verticalAlign: 'middle',
        marginRight: '6px',
        marginBottom: '2px',
    },
    inputContainer: {
        background: 'var(--brand-surface, #fff)',
        borderRadius: '20px',
        padding: '20px 15px',
        width: '100%',
        boxShadow: '0 10px 40px rgba(0,0,0,0.1)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        boxSizing: 'border-box',
        [theme.breakpoints.down('sm')]: {
            padding: '15px 10px',
        },
    },
    textArea: {
        width: '100%',
        border: 'none',
        resize: 'none',
        fontSize: '20px',
        color: 'var(--brand-text, #333)',
        backgroundColor: 'var(--brand-surface, #fff)',
        outline: 'none',
        minHeight: '120px',
        fontFamily: 'inherit',
        marginBottom: '20px',
        '&::placeholder': {
            color: 'var(--brand-text-muted, #bbb)',
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: '16px',
            minHeight: '80px',
        },
    },
    createBtn: {
        background: '#F14A24 !important',
        color: '#fff !important',
        padding: '12px 60px !important',
        borderRadius: '15px !important',
        fontWeight: '800 !important',
        fontSize: '18px !important',
        textTransform: 'none !important',
        '&:hover': {
            background: '#D13A14 !important',
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: '15px !important',
            padding: '7px 16px !important',
        },
    },
    helpText: {
        color: 'var(--brand-text, #000)',
        fontSize: '16px !important',
        marginBottom: '30px !important',
        fontWeight: '800 !important',
        display: 'flex !important',
        alignItems: 'center',
        gap: '4px',
    },
    chips: {
        display: 'grid',
        marginBottom: '50px',
        gridTemplateColumns: '1fr 1fr',
        gap: '10px',
        [theme.breakpoints.down('sm')]: {
            gridTemplateColumns: '1fr',
        },
    },
    chip: {
        background: '#081228 !important',
        color: '#fff !important',
        padding: '12px 30px !important',
        borderRadius: '14px !important',
        fontSize: '15px !important',
        fontWeight: '500 !important',
        textAlign: 'center',
        border: 'none',
        cursor: 'pointer',
        transition: 'all 0.2s',
        '&:hover': {
            transform: 'scale(1.02)',
            backgroundColor: '#222 !important',
        },
    },
    didYouKnowSection: {
        padding: '40px 32px',
        [theme.breakpoints.down('sm')]: {
            padding: '24px 12px',
        },
    },
    didYouKnowTitle: {
        display: 'none',
    },
    statsRow: {
        display: 'grid',
        gridTemplateColumns: 'repeat(6, 1fr)',
        gap: '12px',
        width: '100%',
        maxWidth: '1700px',
        margin: '0 auto',
        [theme.breakpoints.down('md')]: {
            gridTemplateColumns: 'repeat(3, 1fr)',
        },
        [theme.breakpoints.down('sm')]: {
            gridTemplateColumns: 'repeat(2, 1fr)',
        },
        [theme.breakpoints.down('xs')]: {
            gridTemplateColumns: '1fr',
        },
    },
    statCard: {
        background: 'var(--brand-surface, #fff)',
        borderRadius: '16px',
        padding: '16px 14px 14px',
        textAlign: 'left',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        boxSizing: 'border-box',
        boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
        gap: '8px',
        [theme.breakpoints.down('sm')]: {
            padding: '14px 12px',
        },
    },
    statValue: {
        fontSize: '32px !important',
        fontWeight: '800 !important',
        margin: '4px 0 4px 0 !important',
        lineHeight: '1 !important',
    },
    statLabel: {
        fontSize: '13px !important',
        fontWeight: '500 !important',
        color: 'var(--brand-text, #000000)',
        lineHeight: 1.4,
        margin: '0 0 8px 0 !important',
        flexGrow: 1,
    },
    impactSection: {
        padding: '40px 40px',
        textAlign: 'center',
        [theme.breakpoints.down('sm')]: {
            padding: '50px 20px',
        },
    },
    impactTitle: {
        fontSize: '38px !important',
        fontWeight: '800 !important',
        color: 'var(--brand-text, #000000)',
        marginBottom: '20px !important',
        lineHeight: 1.2,
        [theme.breakpoints.down('sm')]: {
            fontSize: '26px !important',
        },
    },
    impactSubtitle: {
        fontSize: '20px !important',
        fontWeight: '400 !important',
        color: 'var(--brand-text, #1a1a1a)',
        marginBottom: '60px !important',
        lineHeight: '1.2 !important',
        [theme.breakpoints.down('sm')]: {
            fontSize: '15px !important',
            marginBottom: '40px !important',
        },
    },
    stepsRow: {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: '40px',
        maxWidth: '1100px',
        margin: '0 auto',
        [theme.breakpoints.down('sm')]: {
            gridTemplateColumns: '1fr',
            gap: '40px',
        },
    },
    stepColumn: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        background: 'var(--brand-surface, rgba(255, 255, 255, 0.45))',
        borderRadius: '20px',
        padding: '28px 24px 20px',
    },
    stepHeading: {
        fontSize: '35px !important',
        fontWeight: '800 !important',
        color: 'var(--brand-text, #1a1a1a)',
        marginBottom: '8px !important',
        [theme.breakpoints.down('sm')]: {
            fontSize: '36px !important',
        },
    },
    stepDesc: {
        fontSize: '18px !important',
        fontWeight: '700 !important',
        color: 'var(--brand-text, #1a1a1a)',
        marginBottom: '12px !important',
        lineHeight: 1.4,
        minHeight: '58px !important',
    },
    stepBody: {
        fontSize: '15px !important',
        fontWeight: '400 !important',
        color: 'var(--brand-text, #2a2a2a)',
        marginBottom: '24px !important',
        lineHeight: 1.6,
    },
    stepCard: {
        background: 'var(--brand-bg, #FBFFE6)',
        borderRadius: '14px',
        padding: '16px',
        width: '100%',
        boxSizing: 'border-box',
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '10px',
        marginTop: 'auto',
        borderTop: '3px solid rgba(255,120,40,0.4)',
    },
    stepCardLabel: {
        fontSize: '11px !important',
        fontWeight: '700 !important',
        color: 'var(--brand-text, #000000)',
        textAlign:'center',
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
    },
    stepCardPills: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '8px',
        width: '100%',
    },
    stepCardPill: {
        background: 'var(--brand-surface, #fff)',
        borderRadius: '20px',
        padding: '7px 20px',
        fontSize: '13px',
        fontWeight: '500',
        color: 'var(--brand-text, #333)',
        width: '100%',
        textAlign: 'center',
        boxSizing: 'border-box',
    },
    stepCardBigNum: {
        fontSize: '30px !important',
        fontWeight: '800 !important',
        color: '#F15A24',
        lineHeight: 1,
    },
    stepCardSubText: {
        fontSize: '14px !important',
        fontWeight: '500 !important',
        color: 'var(--brand-text-muted, #444)',
        lineHeight: 1.4,
    },
    stepCardBarGroup: {
        width: '100%',
        marginBottom: '8px',
    },
    stepCardBarRow: {
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        marginBottom: '4px',
    },
    stepCardDot: {
        width: '8px',
        height: '8px',
        borderRadius: '50%',
        flexShrink: 0,
    },
    stepCardBarLabel: {
        fontSize: '12px !important',
        color: 'var(--brand-text-muted, #555)',
        flex: 1,
        textAlign: 'left',
    },
    stepCardBarValue: {
        fontSize: '13px !important',
        fontWeight: '700 !important',
    },
    stepCardBarTrack: {
        width: '100%',
        height: '6px',
        background: 'var(--brand-border, #eee)',
        borderRadius: '3px',
        overflow: 'hidden',
    },
    stepCardBarFill: {
        height: '100%',
        borderRadius: '3px',
    },
    statBtn: {
        color: 'var(--brand-text, #000000) !important',
        padding: '5px 12px !important',
        borderRadius: '20px !important',
        fontSize: '11px !important',
        fontWeight: '700 !important',
        textTransform: 'none !important',
        lineHeight: '1.3 !important',
        alignSelf: 'flex-start !important',
        whiteSpace: 'normal !important',
        textAlign: 'left !important',
        [theme.breakpoints.down('sm')]: {
            fontSize: '10px !important',
            padding: '4px 10px !important',
        },
    },
    // ── LearnCreator landing, slides 3-4 ─────────────────────────────────────

    /** Slide 3, the reassurance under the button. */
    lcNoExpertise: {
        textAlign: 'center',
        fontSize: '13.5px !important',
        color: 'var(--brand-text-muted, #8A8F98) !important',
        margin: '18px 0 4px !important',
    },

    /*
     * Seven short labels on ONE line, wrapping only when the row runs out.
     * NOT the .chips grid — that is two fixed columns built for long
     * question sentences, and it turned these into four stacked rows.
     */
    lcAudienceRow: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        gap: '10px',
        marginBottom: '4px',
    },
    lcAudChip: {
        padding: '9px 18px',
        borderRadius: '10px',
        border: '1px solid var(--brand-border, #E3E0DB)',
        background: 'var(--brand-surface, #fff)',
        color: 'var(--brand-text, #1B1B1F)',
        fontSize: '14px',
        fontWeight: 600,
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        transition: 'all 0.15s',
        '&:hover': { borderColor: '#FF6900' },
    },
    lcAudChipOn: {
        padding: '9px 18px',
        borderRadius: '10px',
        border: '1px solid #FF6900',
        background: '#FF6900',
        color: '#fff',
        fontSize: '14px',
        fontWeight: 700,
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        transition: 'all 0.15s',
    },

    /** The idea whose category is selected. */
    lcIdeaCardOn: {
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        padding: '16px 18px',
        borderRadius: '14px',
        border: '1px solid #FF6900',
        background: 'rgba(255, 105, 0, 0.07)',
        cursor: 'pointer',
        textAlign: 'left',
        transition: 'all 0.2s',
    },

    // ── LearnCreator landing, slide 4 ────────────────────────────────────────

    /** The label above the prompt box, and above each row below. */
    lcFieldLabel: {
        fontSize: '12px !important',
        fontWeight: '700 !important',
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
        color: 'var(--brand-text-muted, #8A8F98) !important',
        margin: '26px 0 10px !important',
    },
    lcSectionLabel: {
        fontSize: '12px !important',
        fontWeight: '700 !important',
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
        color: 'var(--brand-text-muted, #8A8F98) !important',
        margin: '30px 0 12px !important',
    },

    /* A chosen audience pill. Same geometry as .chip — only the fill moves,
       so the row still reads as one set of controls. */
    lcChipOn: {
        background: '#FF6900 !important',
        color: '#fff !important',
        padding: '12px 30px !important',
        borderRadius: '14px !important',
        fontSize: '15px !important',
        fontWeight: '600 !important',
        textAlign: 'center',
        border: 'none',
        cursor: 'pointer',
        transition: 'all 0.2s',
    },

    /* Four categories across, wrapping to two on a narrow screen — never to
       three, which would leave one card alone on the second row. */
    lcCatRow: {
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gap: '12px',
        [theme.breakpoints.down('md')]: { gridTemplateColumns: 'repeat(2, 1fr)' },
        [theme.breakpoints.down('xs')]: { gridTemplateColumns: '1fr' },
    },
    lcCatCard: {
        display: 'flex',
        flexDirection: 'column',
        gap: '6px',
        padding: '16px 18px',
        borderRadius: '14px',
        border: '1px solid var(--brand-border, #E3E0DB)',
        background: 'var(--brand-surface, #fff)',
        cursor: 'pointer',
        transition: 'all 0.2s',
        '&:hover': { borderColor: '#FF6900' },
    },
    lcCatCardOn: {
        display: 'flex',
        flexDirection: 'column',
        gap: '6px',
        padding: '16px 18px',
        borderRadius: '14px',
        border: '1px solid #FF6900',
        background: 'rgba(255, 105, 0, 0.07)',
        cursor: 'pointer',
        transition: 'all 0.2s',
    },
    lcCatNum: {
        fontSize: '11px',
        fontWeight: 700,
        color: '#FF6900',
        letterSpacing: '0.06em',
    },
    lcCatLabel: {
        fontSize: '15px',
        fontWeight: 700,
        color: 'var(--brand-text, #1B1B1F)',
    },

    /* Idea cards. Text can run to three lines, so the caption is pinned to
       the bottom with margin-top:auto and every card keeps one baseline. */
    lcIdeaRow: {
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gap: '12px',
        marginBottom: '10px',
        [theme.breakpoints.down('md')]: { gridTemplateColumns: 'repeat(2, 1fr)' },
        [theme.breakpoints.down('xs')]: { gridTemplateColumns: '1fr' },
    },
    lcIdeaCard: {
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        padding: '16px 18px',
        borderRadius: '14px',
        border: '1px solid var(--brand-border, #E3E0DB)',
        background: 'var(--brand-surface, #fff)',
        cursor: 'pointer',
        textAlign: 'left',
        transition: 'all 0.2s',
        '&:hover': { borderColor: '#FF6900' },
    },
    lcIdeaText: {
        fontSize: '14px',
        lineHeight: 1.45,
        color: 'var(--brand-text, #1B1B1F)',
    },
    lcIdeaMeta: {
        marginTop: 'auto',
        fontSize: '11px',
        letterSpacing: '0.05em',
        textTransform: 'uppercase',
        color: 'var(--brand-text-muted, #8A8F98)',
    },

    /* The alignment section: explanation on the left, the named list on the
       right in its own scroller so it cannot grow the page. */
    lcAlignBlock: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '28px',
        alignItems: 'start',
        marginTop: '34px',
        paddingTop: '26px',
        borderTop: '1px solid var(--brand-border, #E3E0DB)',
        [theme.breakpoints.down('sm')]: { gridTemplateColumns: '1fr', gap: '16px' },
    },
    lcAlignTitle: {
        fontSize: '20px !important',
        fontWeight: '700 !important',
        color: 'var(--brand-text, #1B1B1F) !important',
        marginBottom: '8px !important',
    },
    lcAlignBody: {
        fontSize: '14px !important',
        lineHeight: '1.55 !important',
        color: 'var(--brand-text-muted, #6B7280) !important',
    },
    /*
     * Tall enough for all five rows. It was 190px, which cut the fifth in
     * half and drew a scrollbar through a list short enough to read whole.
     * overflow stays for the day the list grows; today it never triggers,
     * and the bar is styled thin rather than left as the platform default.
     */
    lcAlignList: {
        maxHeight: '320px',
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',
        scrollbarWidth: 'thin',
        '&::-webkit-scrollbar': { width: '6px' },
        '&::-webkit-scrollbar-thumb': {
            background: 'var(--brand-border, #D8D2CC)',
            borderRadius: '3px',
        },
    },
    lcAlignRow: {
        display: 'flex',
        gap: '14px',
        alignItems: 'baseline',
        padding: '11px 0',
        fontSize: '14px',
        color: 'var(--brand-text, #1B1B1F)',
        borderBottom: '1px solid var(--brand-border, #E3E0DB)',
        '&:last-child': { borderBottom: 'none' },
    },
    lcAlignNum: {
        fontSize: '11px',
        fontWeight: 700,
        color: '#FF6900',
        flexShrink: 0,
    },
}));

export default useStyles;
